export const getProjectFeature = (project, key) =>
  (project?.features || []).find((feature) => feature?.key === key || feature?.Key === key) || null;

export const hasProjectFeature = (project, key) => Boolean(getProjectFeature(project, key));
